import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { StringHelper } from "../../../../../../../utilities/contracts/string-helper";
import { RiskDxIcd } from "../dx-models/response/risk-dx-icd.model";

@Component({
  selector: "app-risk-dx-card-header",
  templateUrl: "./dx-card-header.component.html",
  styleUrls: ["./dx-card-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DxCardHeaderComponent {
  @Input() icdGroup: RiskDxIcd = new RiskDxIcd();

  get showGroupText(): boolean {
    return StringHelper.isAvailable(this.icdGroup?.diagnoses[0]?.groupText);
  }
  get displayHeaderText(): string {
    if (this.icdGroup && this.icdGroup.diagnoses && this.icdGroup.diagnoses.length > 0) {
      const groupText = this.icdGroup.diagnoses[0].groupText;
      const [firstPart, secondPart] = this.splitText(groupText);
      return `[${firstPart}] - ${secondPart}`;
    }
    return "";
  }

  get displayModelName(): string {
    return this.icdGroup?.rxHCC ? "RxHCC" : "HCC";
  }

  splitText(text: string): string[] {
    if (!text) {
      return [];
    }

    const groupText = text.split("-");
    const icdCode = groupText.slice(0, 2).join("-").trim();
    const description = groupText.slice(2).join("-").trim();

    return [icdCode, description];
  }
}
